import React, {useState} from 'react';
import ReactPlayer from 'react-player';
import PlayIcon from '../../static/play-btn.svg';
import * as styles from './video.module.scss';


export const Video = ({ data }) => {
const [playing, setPlaying] = useState(false);
const [pause, setPause] = useState(false);

const { youTubeUrl }=data;

  return (
    <div className='container container-md'>
      <div className={styles.videoWrapper}>
        <ReactPlayer
        url={youTubeUrl}
        width='100%'
        height='100%'
        playing={playing}
        onPlay={()=> setPlaying(true)}
        onPause={()=> setPause(true)}
        />
      {(!playing && !pause) && (
        <div className={styles.playBtnWrapper}>
          <button
            className={styles.playBtn}
            onClick={()=> setPlaying(true)}
          >
            <PlayIcon/>
          </button>
        </div>
      )}
    </div>
    </div>
  );
}